import { dateRangePickerIntlIds } from './date-range-picker.ids';

export const dateRangePickerLangPtBr = {
  [dateRangePickerIntlIds.selectPeriodOrDateInput.placeholder]:
    'Selecione um período ou data',
  [dateRangePickerIntlIds.goBackToTodayButton.label]: 'Hoje',
  [dateRangePickerIntlIds.clearSelectedPeriodButton.label]: 'Limpar seleção',
  [dateRangePickerIntlIds.cancelButton.label]: 'Cancelar',
  [dateRangePickerIntlIds.selectPeriodButton.label]: 'Selecionar',
  [dateRangePickerIntlIds.previousMonthAria.label]: 'Mês anterior',
  [dateRangePickerIntlIds.nextMonthAria.label]: 'Mês seguinte',
};
